export let fetchAnnotations = `
  annotations {
    id
    submitter_id
    category
    creator
    updated_datetime
    notes
  }
`;

export let clinicalLinksQuery = `
  _links {
    id
    type
    ...on treatment {
      submitter_id
    }
    ...on diagnosis {
      submitter_id
    }
  }
`;

export let dataBundleQuery = `
  submittedFilesCount: _submitted_files_count
  completeness
`;

export let dataBundlesDetailsQuery = `
  submitted_files { id submitter_id file_name file_state data_format file_size }
  ${fetchAnnotations}
`;
